var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SubscriptionDialog,{key:_setup.i18n.locale,ref:"dialogCtx"})
}
var staticRenderFns = []

export { render, staticRenderFns }